import { render, staticRenderFns } from "./Overdue.vue?vue&type=template&id=7b125b94&scoped=true&"
import script from "./Overdue.vue?vue&type=script&lang=js&"
export * from "./Overdue.vue?vue&type=script&lang=js&"
import style0 from "./Overdue.vue?vue&type=style&index=0&id=7b125b94&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b125b94",
  null
  
)

export default component.exports